enum DisplayNames {
  SideBar = 'SideBar',
  SideBarFooter = 'SideBarFooter',
  SideBarHeading = 'SideBarHeading',
  SideBarItem = 'SideBarItem',
  SideBarItemGroup = 'SideBarItemGroup',
  SideBarItemLeftElement = 'SideBarItemLeftElement',
  SideBarItemRightElement = 'SideBarItemRightElement',
  SideBarSection = 'SideBarSection'
}

export default DisplayNames;
